var _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanitP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 68,
    fill: "#1F2937"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 56,
    fill: "#FDE68A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 118,
    fontFamily: "Inter, Arial",
    fontSize: 68,
    fontWeight: 700,
    textAnchor: "middle",
    fill: "#0B1220"
  }, "P")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanitP);
export default __webpack_public_path__ + "static/media/planit-p.13a1ae52b42fad603d6469d3174eb949.svg";
export { ForwardRef as ReactComponent };